import api from "@/services/axiosInstance";

const API_BASE_URL = process.env.VUE_APP_BACKEND_URL;
const content = "sale";
const version = "v1";

// orders
export const createV1Order = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/orders/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating order at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied" };
    }

    throw error;
  }
};

export const fetchV1Orders = async (
  page = 1,
  pageSize = 5,
  customer = null
) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/orders/?page_size=${pageSize}&page=${page}`;

  if (customer) {
    URL += `&customer=${customer}`;
  }

  console.log("Orders API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};


export const fetchV1Order = async (orderCode = null) => {
  const URL = `${API_BASE_URL}/${content}/${version}/orders/${orderCode}/`;
  console.log("Order Details API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching order:", error);
    throw error;
  }
};